import { LocalizationText } from "@/app/index";
import { Alert, Button, Text, Typography } from "@/base/components/index";
import { Link } from "@/components/link";
import { useContextPageRoot } from "../../context/root-context";
import { useHeaderSystemViewStyles } from "./header-system-view.styles";

export const HeaderSystemView = () => {
  const { styles } = useHeaderSystemViewStyles();
  const { localization, systemView } = useContextPageRoot();
  const { currentLang } = localization;
  const { userData, reset } = systemView;
  return (
    <Alert
      type="warning"
      className={styles.systemView}
      message={
        <Typography>
          <Text>
            <LocalizationText value="root.header.system.view.message.supervisor.mode" />{" "}
          </Text>
          {userData && (
            <>
              <LocalizationText
                value="root.header.system.view.message.delegate.user"
                hasTextCmp={true}
                templateData={{
                  login: <Text strong>{userData?.Login || ""}</Text>,
                  resetButton: (
                    <Button
                      size="large"
                      variant="text"
                      color="primary"
                      onClick={reset}
                    >
                      <LocalizationText value="root.header.system.view.button.reset" />
                    </Button>
                  ),
                }}
              />{" "}
            </>
          )}
          <Text>
            <LocalizationText
              value="root.header.system.view.message.manage.delegate"
              templateData={{
                hereButton: (
                  <Link to={`/${currentLang}/delegate`}>
                    <LocalizationText value="root.header.system.view.button.here" />
                  </Link>
                ),
              }}
            />
          </Text>
        </Typography>
      }
    />
  );
};
